import AxiosClient from "../AxiosClient";

export const postSearchOrderSummaryApi = (params) => {
  const url = "/api/orderSummary/searchOrderSummary";
  return AxiosClient.post(url, params);
};

export const postSearchInitialOrderSummaryApi = (params) => {
  const url = "/api/orderSummary/searchInitialOrderSummary";
  return AxiosClient.post(url, params);
};
